import { Button } from '@aircall/tractor-v2';
import { RolesFilter } from '@components/RolesFilter';
import { SearchBar } from '@components/SearchBar';
import { TeamsFilter } from '@components/TeamsFilter';
import { Gap } from '@dashboard/library';
import { useFeatures } from '@hooks/useFeatures/useFeatures';
import { LIST_VIEW_PARAMS, useListViewFilters } from '@hooks/useListViewFilters';
import { useTranslation } from 'react-i18next';

interface AgentsFiltersProps {
  searchTerm: string | null;
}

export function AgentsFilters({ searchTerm }: AgentsFiltersProps) {
  const { t } = useTranslation();
  const { get, set, setDebounced, setMultiple } = useListViewFilters();
  const { dashboardListViewFilters } = useFeatures();
  const teamsIds = get(LIST_VIEW_PARAMS.TEAMS);
  const roles = get(LIST_VIEW_PARAMS.ROLES);

  function handleFilterDebounced(filter: LIST_VIEW_PARAMS) {
    return (value: string | string[]) => {
      setDebounced(filter, value);
    };
  }

  function handleFilter(filter: LIST_VIEW_PARAMS) {
    return (value: string | string[]) => {
      set(filter, value);
    };
  }

  function handleReset() {
    setMultiple({
      [LIST_VIEW_PARAMS.TEAMS]: [],
      [LIST_VIEW_PARAMS.AVAILABILITY]: [],
      [LIST_VIEW_PARAMS.ROLES]: [],
    });
  }

  return (
    <Gap flexWrap='wrap' columnGap='s' rowGap='xs' alignItems='center'>
      <SearchBar
        w='240px'
        value={searchTerm}
        name='users-search'
        placeholder={t('users.search.placeholder')}
        onSearch={handleFilter(LIST_VIEW_PARAMS.SEARCH)}
        onClear={() => handleFilter(LIST_VIEW_PARAMS.SEARCH)('')}
        size='small'
      />

      {dashboardListViewFilters && (
        <>
          <TeamsFilter
            initialTeamsIds={teamsIds}
            onSelect={handleFilterDebounced(LIST_VIEW_PARAMS.TEAMS)}
          />

          <RolesFilter
            initialRoles={roles}
            onSelect={handleFilterDebounced(LIST_VIEW_PARAMS.ROLES)}
          />

          <Button
            data-test='agents-filters-reset'
            mode='ghost'
            variant='secondary'
            onClick={handleReset}
          >
            {t('generic.reset')}
          </Button>
        </>
      )}
    </Gap>
  );
}
